module.exports = __webpack_public_path__ + "img/inclusivos-icon.d68db1c5.svg";